import { atom } from "recoil";

const storedState = localStorage.getItem("newComissionState");

let state = true;

if (storedState) {
    state = JSON.parse(storedState);
}

export const newComissionState = atom<boolean>({
    key: "newComissionState",
    default: state,
});